import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ImagilityBaseResponse } from 'src/app/data/models/response.model';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})
export class SettingsApiService {
    encriptedData: string;
    constructor(private httpClient: HttpClient) {
    }

   // username  modification services
    getUserName(beneficiaryId) {
        return this.httpClient.get(`/beneficiary/${beneficiaryId}/settings/profile/username`).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response.status) {
                    return response.data;
                }
            })
        );
    }
   
    saveUserName(beneficiaryId,  payload){
        return this.httpClient.post(`/beneficiary/${beneficiaryId}/settings/profile/username`, payload).pipe(
          map((response: ImagilityBaseResponse) => response)
        );
      }

   // profile search visibility settings  
    getSearchVisibility(beneficiaryId) {
        return this.httpClient.get(`/beneficiary/${beneficiaryId}/settings/privacy/visibility`).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response.status) {
                    return response.data;
                }
            })
        );
    }

    getLanguagesList() {
        return this.httpClient.get(`/referenceLibrary/FOREIGNLANGUAGE`);
    }

    getCurrentLanguage(beneficiaryId) {
        return this.httpClient.get(`/beneficiary/${beneficiaryId}/language`);
    }

    changeLanguage(beneficiaryId, preferredLanguage) {
        preferredLanguage = this.toEncrypt(preferredLanguage);
        return this.httpClient.put(`/beneficiary/${beneficiaryId}/updateLanguage/${preferredLanguage}`, {});
    }

    setSearchVisibility(beneficiaryId,payload) {
      return this.httpClient.post(`/beneficiary/${beneficiaryId}/settings/privacy/visibility`, payload).pipe(
        map((response: ImagilityBaseResponse) => response)
      );
    }
   
    //get profile edit visibility settings
    getProfileEditPermission(beneficiaryId) {
        return this.httpClient.get(`/beneficiary/${beneficiaryId}/settings/privacy/edit`).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response.status) {
                    return response.data;
                }
            })
        );
    }

    //save profile edit visibility settings
    setProfileEditPermission(beneficiaryId, payload) {
        return this.httpClient.post(`/beneficiary/${beneficiaryId}/settings/privacy/edit`, payload).pipe(
            map((response: ImagilityBaseResponse) => response)
        );
    }

    updateCommEmail(beneficiaryId,payload){
        return this.httpClient.post(`/beneficiary/${beneficiaryId}/settings/profile/communicationEmail`, payload).pipe(
            map((response: ImagilityBaseResponse) => response)
        );
    }

    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65'
        var data = _data;
        var key  = CryptoJS.enc.Latin1.parse(pharase);
        var iv   = CryptoJS.enc.Latin1.parse(pharase);  
        var encrypted = CryptoJS.AES.encrypt(
          data,
          key,
          {iv:iv,mode:CryptoJS.mode.CBC,
            padding:CryptoJS.pad.ZeroPadding
        }).toString();
    
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
    
       return this.encriptedData = eHex;
      }

}
